import React from 'react';

// blur: tailwind blur class. Lower = more present/defined.
const FloatingBlob = ({ className, blur = 'blur-2xl' }) => (
  <div
    className={`absolute rounded-full mix-blend-multiply ${blur} animate-blob ${className}`}
  />
);

export default FloatingBlob;
